module.exports = __webpack_public_path__ + "static/media/border-top.8754d33f.png";